import {
  REQUEST_CITIES, RECEIVE_CITIES, RECEIVE_CITY,
} from '../actions/cities';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_CITIES:
      return { ...state, loading: true };
    case RECEIVE_CITIES:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_CITY:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
